module.exports = __webpack_public_path__ + "img/Inflammation-BRCA_GSE176078.e42d6696.png";